import { useTranslation } from "react-i18next";
import type { Market } from "@ferrivia/api-contract";
import { getMarket } from "./createI18n";

export function useMarket(): Market {
  const { i18n } = useTranslation();
  return getMarket(i18n);
}
